import { accessRole } from "../../../helpers/access_role";
import ErrorAccess from "../../../components/Error/Content/Access";

import IndexView from "./Index/View";
import CreateView from "./Create/View";
import CreatePenilaianView from "./CreatePenilaian/View";
import UpdatePenilaianView from "./UpdatePenilaian/View";
import PreviewPenilaianView from "./PreviewPenilaian/View";

const RouteView = (props) => {
  const queryParams = new URLSearchParams(props.location.search);
  // const _uuid = queryParams.get("uuid");
  const _create = queryParams.get("create");
  const _create_penilaian = queryParams.get("create_assestment");
  const _update_penilaian = queryParams.get("update_assestment");
  const _preview_penilaian = queryParams.get("preview_assestment");

  if (_create != null) {
    return accessRole("create") ? <CreateView /> : <ErrorAccess />;
  }
  if (_create_penilaian != null) {
    return accessRole("create") ? <CreatePenilaianView /> : <ErrorAccess />;
  }

  if (_update_penilaian != null) {
    return accessRole("update") ? <UpdatePenilaianView /> : <ErrorAccess />;
  }

  if (_preview_penilaian != null) {
    return accessRole("update") ? <PreviewPenilaianView /> : <ErrorAccess />;
  }
  return accessRole("read") ? <IndexView /> : <ErrorAccess />;
};
export default RouteView;
